(() => {
  angular
    .module('app.core')
    .factory('MigrationNotification', MigrationNotification)
    .controller('MigrationNotificationController', MigrationNotificationController);

  function MigrationNotification() {
    const alert = this;
    alert.visible = false;
    alert.show = () => alert.visible = true;
    alert.hide = () => alert.visible = false;

    return alert;
  }

  MigrationNotificationController.$inject = [
    '$scope',
    '$filter',
    '$interval',
    'MigrationNotification',
  ];

  function MigrationNotificationController(
    $scope,
    $filter,
    $interval,
    MigrationNotification,
  ) {
    const vm = this;
    const currentUser = $('#current-user');

    $scope.$watch(() => MigrationNotification.visible,
      visible => vm.show = visible);

    const requestMigrationDate = (query, variables) => {
      const endpoint = `${currentUser.data('apapi')}/ar/migration/v1/graphql`;
      const headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${vm.idToken}`,
      };

      return fetch(endpoint, {
        headers,
        method: 'POST',
        body: JSON.stringify({
          query: query.replace(/\s/g, ''),
          variables,
        })
      }).then(response => response.json())
    };

    const loadMigrationDate = () => {
      const accountId = currentUser.data('company-id');
      const query = `query(
          $accountId: Int!
        ) {
          accountIntegrationMigration(
            accountId: $accountId
          ) {
            migrationDate
          }
        }`;

      requestMigrationDate(query, {
        accountId,
      })
        .then(json => {
          if (!json.errors) {
            const { migrationDate } = json.data.accountIntegrationMigration;
            localStorage.setItem(`migrationDate${accountId}`, migrationDate);
            vm.migrationDate = $filter('dateLong')(migrationDate);

            if (new Date(migrationDate) <= new Date()) {
              MigrationNotification.show();
            }
          } else {
            localStorage.removeItem(`migrationDate${accountId}`);

            MigrationNotification.hide();
          }
        });
    };

    const interval = $interval(() => {
      vm.idToken = localStorage.getItem('idToken');

      if (vm.idToken) {
        loadMigrationDate();

        $interval.cancel(interval);
      }
    }, 300);
  }
})();
